<i18n>
{
  "fr": {
    "no-luggage": "Pas de bagages",
    "quantity": "Quantité :",
    "weight": "Poids :",
    "price": "Prix :"
  },
  "en": {
    "no-luggage": "No luggage",
    "quantity": "Quantity :",
    "weight": "Weight :",
    "price": "Price :"
  }
}
</i18n>

<template>
  <v-col
    v-if="selectedOption !== 'NO_OPTION_SELECTED'"
    class="px-6"
  >
    <div class="d-flex justify-space-between">
      <div>
        {{ $t('quantity') }}
      </div>
      <div>{{ removePluralAndTranslate(selectedOption.quantity) }}</div>
    </div>
    <div class="d-flex justify-space-between">
      <div>
        {{ $t('weight') }}
      </div>
      <div>{{ formatLuggageWeightDetails(selectedOption.weight) }}</div>
    </div>
    <div class="d-flex justify-space-between">
      <div>
        {{ $t('price') }}
      </div>
      <div>{{ formatPriceWithNarrowSymbol(selectedOption.amount, selectedOption.currency) }}</div>
    </div>
  </v-col>
  <div
    v-else
    class="d-flex justify-center align-center fill-height text--disabled"
  >
    <v-icon class="mr-2 text--disabled">
      mdi-bag-carry-on-off
    </v-icon><span>{{ $t('no-luggage') }}</span>
  </div>
</template>

<script>
import luggageOptionsMixin from '@/mixins/luggageOptions'
import globalMixin from '@/mixins/global'

export default {
  name: 'FlightLuggageOptionDetails',
  mixins: [luggageOptionsMixin, globalMixin],
  props: {
    selectedOption: {
      type: [Object, String],
      required: true
    }
  }
}
</script>

<style scoped>
</style>
